import { useConfigMutation } from "@hooks";

import * as Apis from "../api";

const useAccountsPayableMutation = (() => {
  return useConfigMutation({ apis: Apis });
})();

export default useAccountsPayableMutation;
